import { EnumMenu } from "model";

export const farmaceuticoMenuEnumPermissao = [
    EnumMenu.OPERACIONAL_CONTROLESALAO_GERAR_COMANDA,
    EnumMenu.OPERACIONAL_DENTROVENDA_ACOMPANHAMENTO_MESA
]